import { useTypedSelector } from "../../stores/hooks";
import { PricingAnalysisFormState } from "../../stores/slices/pricingAnalysisSlice";

export const usePricingAnalysisState = (): PricingAnalysisFormState => {
  const state = useTypedSelector(({ pricingAnalysis }) => pricingAnalysis);
  return state;
};
